var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28 28.475H1l10.058-11.633a.985.985 0 0 0 0-1.295L1.086 4h3.151l10.036 11.633c.26.345.302.842.022 1.166A4324.993 4324.993 0 0 0 4.28 28.474zM30.936 4h-3.15L15.093 18.784c-.324.367-.346.95-.022 1.317l.345.432 6.799 7.943h3.28l-7.36-8.569a1.014 1.014 0 0 1 .022-1.316L30.935 4zM20.468 19.022c-.065.302 0 .647.215.885 1.835 2.136 7.339 8.568 7.339 8.568H31L21.61 17.619l-.84.927c-.13.13-.238.302-.302.475zM6.74 4h3.023s5.417 6.475 7.36 8.46c.323.324.258.734-.022 1.058a165.05 165.05 0 0 1-1.057 1.252L6.741 4zm12.087 7.51L25.281 4h-3.064l-3.367 3.928-.972 1.144a1.014 1.014 0 0 0-.022 1.317c.237.28.971 1.12.971 1.12zM6.763 28.476l6.453-7.51.95 1.121c.323.389.302.95-.022 1.317l-.971 1.144-3.367 3.928H6.763z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImx);
export default __webpack_public_path__ + "static/media/IMX.ae4c738e05d23733b141bd34a54e2095.svg";
export { ForwardRef as ReactComponent };